import { printf, toText } from "../../../fable_modules/fable-library-js.4.19.0/String.js";
import * as react from "react";
import { empty, singleton, append, delay, toList } from "../../../fable_modules/fable-library-js.4.19.0/Seq.js";
import { validatedTextarea, checkbox, validatedTextBox, errorMsg, spinner, icon } from "../../../../Bfs.Web.Portale/ViewParts.fs.js";
import { EditModel__get_CanSubmit, Msg } from "./Types.fs.js";
import { toArray, singleton as singleton_1, empty as empty_1, map } from "../../../fable_modules/fable-library-js.4.19.0/List.js";
import { defaultArg, value as value_1 } from "../../../fable_modules/fable-library-js.4.19.0/Option.js";
import { equals } from "../../../fable_modules/fable-library-js.4.19.0/Util.js";
import { Option, ISize, column } from "../../../fable_modules/Fulma.3.0.0/Layouts/Column.fs.js";
import { Screen } from "../../../fable_modules/Fulma.3.0.0/Common.fs.js";
import { Option as Option_1, select } from "../../../fable_modules/Fulma.3.0.0/Elements/Form/Select.fs.js";
import { DangerousHtml, DOMAttr, HTMLAttr } from "../../../fable_modules/Fable.React.9.4.0/Fable.React.Props.fs.js";
import { keyValueList } from "../../../fable_modules/fable-library-js.4.19.0/MapUtil.js";
import { tryParse } from "../../../fable_modules/fable-library-js.4.19.0/Guid.js";
import { FSharpRef } from "../../../fable_modules/fable-library-js.4.19.0/Types.js";

export function tableRow(dispatch, faq) {
    let children, children_12, children_20, children_14, children_16, children_18;
    const aktiv = faq.Aktiv ? "" : "deaktiviert";
    const children_22 = [(children = [toText(printf("%i."))(faq.Position)], react.createElement("td", {}, ...children)), react.createElement("td", {}, faq.Frage), (children_12 = toList(delay(() => append(faq.SichtbarFuerPflege ? singleton(react.createElement("span", {
        className: "tag is-small is-info is-light",
    }, "Pflege")) : empty(), delay(() => append(faq.SichtbarFuerPflegeDtaPlus ? singleton(react.createElement("span", {
        className: "tag is-small is-info is-light",
    }, "DTA-Plus")) : empty(), delay(() => append(faq.SichtbarFuerTherapie ? singleton(react.createElement("span", {
        className: "tag is-small is-info is-light",
    }, "Therapie")) : empty(), delay(() => (faq.SichtbarFuerJugendhilfe ? singleton(react.createElement("span", {
        className: "tag is-small is-info is-light",
    }, "Jugendhilfe")) : empty()))))))))), react.createElement("td", {}, ...children_12)), (children_20 = [(children_14 = [icon("fas fa-edit")], react.createElement("a", {
        onClick: (_arg) => {
            dispatch(new Msg(8, [faq.Id]));
        },
        title: "bearbeiten",
    }, ...children_14)), faq.Aktiv ? ((children_16 = [icon("fas fa-eye-slash")], react.createElement("a", {
        onClick: (_arg_1) => {
            dispatch(new Msg(5, [faq.Id]));
        },
        title: "deaktivieren",
    }, ...children_16))) : ((children_18 = [icon("fas fa-eye")], react.createElement("a", {
        onClick: (_arg_2) => {
            dispatch(new Msg(4, [faq.Id]));
        },
        title: "aktivieren",
    }, ...children_18)))], react.createElement("td", {}, ...children_20))];
    return react.createElement("tr", {
        className: aktiv,
    }, ...children_22);
}

export function table(faqs, dispatch) {
    let children_10, children_8, children_12;
    const children_14 = [(children_10 = [(children_8 = [react.createElement("th", {}, "Pos."), react.createElement("th", {}, "Frage"), react.createElement("th", {}, "Sichtbar für"), react.createElement("th", {}, "Aktionen")], react.createElement("tr", {}, ...children_8))], react.createElement("thead", {}, ...children_10)), (children_12 = map((faq) => tableRow(dispatch, faq), faqs), react.createElement("tbody", {}, ...children_12))];
    return react.createElement("table", {
        className: "table table-striped responsive-table",
    }, ...children_14);
}

export function faqList(model, dispatch) {
    const children_10 = toList(delay(() => {
        let children_8, children_6;
        return singleton((children_8 = [(children_6 = toList(delay(() => append(singleton(react.createElement("button", {
            className: "button is-link is-pulled-right is-small",
            onClick: (_arg) => {
                if (model.SelectedKategorie != null) {
                    dispatch(new Msg(7, [value_1(model.SelectedKategorie)]));
                }
            },
        }, "Neu")), delay(() => {
            let matchValue;
            return singleton((matchValue = model.Faqs, (matchValue.tag === 1) ? spinner : ((matchValue.tag === 2) ? errorMsg("Fehler beim Laden der FAQs!") : ((matchValue.tag === 3) ? (equals(matchValue.fields[0], empty_1()) ? react.createElement("div", {}, "Keine FAQs vorhanden") : table(matchValue.fields[0], dispatch)) : react.createElement("div", {})))));
        })))), react.createElement("div", {
            className: "card-body",
        }, ...children_6))], react.createElement("div", {
            className: "flat-card profile-info-card is-auto",
        }, ...children_8)));
    }));
    return react.createElement("div", {
        className: "column is-8",
    }, ...children_10);
}

export function editBox(kategorien, model, dispatch) {
    let children_94, children_4, children_2, children_92, children_10, children_8, children_6, children_24, children_14, children_12, children_22, children_20, children_18, children_30, children_28, children_26, children_44, children_42, children_40, children_38, children_36, children_78, children_52, children_50, children_48, children_60, children_58, children_56, children_68, children_66, children_64, children_76, children_74, children_72, children_90, children_88, children_82, props_80, children_86, children_84;
    const isLoading = model.Sending ? " is-loading" : "";
    return column(singleton_1(new Option(0, [new Screen(0, []), new ISize(10, [])])), singleton_1((children_94 = [(children_4 = [(children_2 = [react.createElement("b", {}, "FAQ bearbeiten")], react.createElement("h3", {}, ...children_2))], react.createElement("div", {
        className: "card-title",
    }, ...children_4)), (children_92 = [(children_10 = [(children_8 = [(children_6 = [validatedTextBox((arg) => {
        dispatch(new Msg(10, [arg]));
    })("Frage")("Frage")("")(model.Frage)], react.createElement("div", {
        className: "info-block",
    }, ...children_6))], react.createElement("div", {
        className: "column is-12",
    }, ...children_8))], react.createElement("div", {
        className: "columns",
    }, ...children_10)), (children_24 = [(children_14 = [(children_12 = [validatedTextBox((arg_1) => {
        dispatch(new Msg(12, [arg_1]));
    })("Position")("Position")("")(model.Position)], react.createElement("div", {
        className: "info-block",
    }, ...children_12))], react.createElement("div", {
        className: "column is-8",
    }, ...children_14)), (children_22 = [(children_20 = [(children_18 = [react.createElement("label", {
        className: "label",
    }, "Aktiv"), checkbox(model.Aktiv, (b) => {
        dispatch(new Msg(13, [b]));
    }, "")], react.createElement("div", {
        className: "field",
    }, ...children_18))], react.createElement("div", {
        className: "info-block",
    }, ...children_20))], react.createElement("div", {
        className: "column is-4",
    }, ...children_22))], react.createElement("div", {
        className: "columns",
    }, ...children_24)), (children_30 = [(children_28 = [(children_26 = [validatedTextarea((arg_2) => {
        dispatch(new Msg(11, [arg_2]));
    }, "Antwort", "Antwort", "", "is-big", model.Antwort)], react.createElement("div", {
        className: "info-block",
    }, ...children_26))], react.createElement("div", {
        className: "column is-12",
    }, ...children_28))], react.createElement("div", {
        className: "columns",
    }, ...children_30)), (children_44 = [(children_42 = [(children_40 = [(children_38 = [react.createElement("label", {
        className: "label",
    }, "Kategorie"), select(singleton_1(new Option_1(11, [""])), singleton_1((children_36 = map((k) => {
        const props_34 = [new HTMLAttr(161, [k.Id]), new HTMLAttr(143, [k.Id === model.KategorieId])];
        return react.createElement("option", keyValueList(props_34, 1), k.Anzeigename);
    }, kategorien), react.createElement("select", {
        className: "select input is-multiline is-multiple",
        onChange: (ev) => {
            let matchValue;
            let outArg = "00000000-0000-0000-0000-000000000000";
            matchValue = [tryParse(ev.target.value, new FSharpRef(() => outArg, (v) => {
                outArg = v;
            })), outArg];
            if (matchValue[0]) {
                dispatch(new Msg(14, [matchValue[1]]));
            }
        },
    }, ...children_36))))], react.createElement("div", {
        className: "field",
    }, ...children_38))], react.createElement("div", {
        className: "info-block",
    }, ...children_40))], react.createElement("div", {
        className: "column is-12",
    }, ...children_42))], react.createElement("div", {
        className: "columns",
    }, ...children_44)), (children_78 = [(children_52 = [(children_50 = [(children_48 = [react.createElement("label", {
        className: "label",
    }, "für Pflege"), checkbox(model.SichtbarFuerPflege, (b_1) => {
        dispatch(new Msg(15, [b_1]));
    }, "a")], react.createElement("div", {
        className: "field",
    }, ...children_48))], react.createElement("div", {
        className: "info-block",
    }, ...children_50))], react.createElement("div", {
        className: "column is-3",
    }, ...children_52)), (children_60 = [(children_58 = [(children_56 = [react.createElement("label", {
        className: "label",
    }, "für DTA-Plus"), checkbox(model.SichtbarFuerPflegeDtaPlus, (b_2) => {
        dispatch(new Msg(16, [b_2]));
    }, "b")], react.createElement("div", {
        className: "field",
    }, ...children_56))], react.createElement("div", {
        className: "info-block",
    }, ...children_58))], react.createElement("div", {
        className: "column is-3",
    }, ...children_60)), (children_68 = [(children_66 = [(children_64 = [react.createElement("label", {
        className: "label",
    }, "für Therapie"), checkbox(model.SichtbarFuerTherapie, (b_3) => {
        dispatch(new Msg(17, [b_3]));
    }, "c")], react.createElement("div", {
        className: "field",
    }, ...children_64))], react.createElement("div", {
        className: "info-block",
    }, ...children_66))], react.createElement("div", {
        className: "column is-3",
    }, ...children_68)), (children_76 = [(children_74 = [(children_72 = [react.createElement("label", {
        className: "label",
    }, "für Jugendhilfe"), checkbox(model.SichtbarFuerJugendhilfe, (b_4) => {
        dispatch(new Msg(18, [b_4]));
    }, "d")], react.createElement("div", {
        className: "field",
    }, ...children_72))], react.createElement("div", {
        className: "info-block",
    }, ...children_74))], react.createElement("div", {
        className: "column is-3",
    }, ...children_76))], react.createElement("div", {
        className: "columns",
    }, ...children_78)), (children_90 = [(children_88 = [(children_82 = [(props_80 = [new HTMLAttr(65, ["button is-link" + isLoading]), new HTMLAttr(79, [!EditModel__get_CanSubmit(model)]), new DOMAttr(40, [(_arg) => {
        dispatch(new Msg(19, []));
    }])], react.createElement("button", keyValueList(props_80, 1), "Speichern"))], react.createElement("div", {
        className: "info-block is-pulled-right",
    }, ...children_82)), (children_86 = [(children_84 = [model.IsDirty ? "Abbrechen" : "Zurück"], react.createElement("button", {
        className: "button is-danger is-link",
        onClick: (_arg_1) => {
            dispatch(new Msg(2, [model.KategorieId]));
        },
    }, ...children_84))], react.createElement("div", {
        className: "info-block",
    }, ...children_86))], react.createElement("div", {
        className: "column is-12",
    }, ...children_88))], react.createElement("div", {
        className: "columns",
    }, ...children_90))], react.createElement("div", {
        className: "card-body",
    }, ...children_92))], react.createElement("div", {
        className: "flat-card profile-info-card is-auto",
    }, ...children_94))));
}

export function previewBox(model) {
    let children_10, children_4, children_2, children_8, props_6;
    return column(singleton_1(new Option(0, [new Screen(0, []), new ISize(10, [])])), singleton_1((children_10 = [[(children_4 = [(children_2 = [react.createElement("b", {}, model.Frage.Value)], react.createElement("h3", {}, ...children_2))], react.createElement("div", {
        className: "card-title",
    }, ...children_4)), (children_8 = [(props_6 = [new HTMLAttr(65, ["content"]), new DOMAttr(0, [new DangerousHtml(model.TextAsHtml)])], react.createElement("div", keyValueList(props_6, 1)))], react.createElement("div", {
        className: "card-body",
    }, ...children_8))]], react.createElement("div", {
        className: "flat-card profile-info-card is-auto",
    }, ...children_10))));
}

export function kategorienList(kategorien, selectedKategorie, dispatch) {
    let children_8, children_6;
    const children_10 = [(children_8 = [(children_6 = [toArray(map((k) => {
        let children_2;
        const props_4 = [new HTMLAttr(65, ["wishlist-item " + ((k.Id === selectedKategorie) ? " is-active" : "")]), new DOMAttr(40, [(_arg) => {
            dispatch(new Msg(2, [k.Id]));
        }])];
        const children_4 = [(children_2 = toList(delay(() => singleton(react.createElement("a", {}, k.Anzeigename)))), react.createElement("div", {
            className: "item-wrapper",
        }, ...children_2))];
        return react.createElement("li", keyValueList(props_4, 1), ...children_4);
    }, kategorien))], react.createElement("ul", {
        className: "wishlists",
    }, ...children_6))], react.createElement("div", {
        className: "flat-card is-auto menu-card",
    }, ...children_8))];
    return react.createElement("div", {
        className: "column is-4",
    }, ...children_10);
}

export function view(model, dispatch, navigateTo) {
    const matchValue = model.EditModel;
    if (matchValue == null) {
        const children_2 = [kategorienList(model.Kategorien, defaultArg(model.SelectedKategorie, "00000000-0000-0000-0000-000000000000"), dispatch), faqList(model, dispatch)];
        return react.createElement("div", {
            className: "columns is-product-list is-multiline faq",
        }, ...children_2);
    }
    else {
        const editModel = matchValue;
        const children = [editBox(model.Kategorien, editModel, dispatch), previewBox(editModel)];
        return react.createElement("div", {
            className: "columns is-multiline",
        }, ...children);
    }
}

//# sourceMappingURL=View.fs.js.map
